function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { LockOutlined } from "@mui/icons-material";
import { InputLabel, styled } from "@mui/material";
import { useCamelCase } from "@vestwell-frontend/hooks";
import { useToggle } from "react-use";
import { IconTooltip } from "../IconTooltip";
import { Modal } from "../Modal";
import { ModalBody } from "../ModalBody";
var Details = styled('p')(function(param) {
    var theme = param.theme;
    return {
        color: theme.palette.grey[300],
        fontSize: '.875rem',
        lineHeight: 1.625,
        maxWidth: '39.9375em'
    };
});
export var FormFieldLabel = function(props) {
    var _useToggle = _sliced_to_array(useToggle(false), 2), isModalOpen = _useToggle[0], toggleIsModalOpen = _useToggle[1];
    var testIdName = useCamelCase(props.name);
    return !props.label || props.hideLabel ? /*#__PURE__*/ _jsx("label", {
        className: "sr-only",
        "data-component": props['data-component'],
        "data-testid": testIdName,
        id: props.labelId,
        children: props.label || props.name
    }) : /*#__PURE__*/ _jsxs("div", {
        className: "flex flex-col",
        children: [
            /*#__PURE__*/ _jsxs("div", {
                className: "flex items-center",
                children: [
                    /*#__PURE__*/ _jsx(InputLabel, {
                        "data-component": props['data-component'],
                        "data-testid": testIdName,
                        disabled: props.disabled,
                        id: props.labelId,
                        required: !!props.required,
                        shrink: false,
                        children: props.label
                    }),
                    props.disabled && !props.hideLocked && /*#__PURE__*/ _jsx(IconTooltip, {
                        "aria-label": "Disabled",
                        "data-component": "".concat(props['data-component'], "Disabled"),
                        "data-testid": testIdName,
                        id: props.disabledId,
                        trigger: /*#__PURE__*/ _jsx(LockOutlined, {
                            fontSize: "small"
                        })
                    }),
                    props.info && /*#__PURE__*/ _jsx(IconTooltip, {
                        "aria-label": "More Info On ".concat(props.label),
                        "data-component": "".concat(props['data-component'], "Info"),
                        "data-testid": testIdName,
                        id: props.infoId,
                        children: props.info
                    }),
                    props.helpModal && /*#__PURE__*/ _jsxs(_Fragment, {
                        children: [
                            /*#__PURE__*/ _jsx(IconTooltip, {
                                "aria-label": "Info for ".concat(props.label),
                                "data-component": "".concat(props['data-component'], "InfoModal"),
                                "data-testid": testIdName,
                                id: props.helpModalId,
                                onClick: toggleIsModalOpen
                            }),
                            /*#__PURE__*/ _jsx(Modal, {
                                "aria-labelledby": props.helpModalId,
                                closeButton: true,
                                isOpen: isModalOpen,
                                onRequestClose: toggleIsModalOpen,
                                children: /*#__PURE__*/ _jsx(ModalBody, {
                                    children: props.helpModal
                                })
                            })
                        ]
                    })
                ]
            }),
            props.details && /*#__PURE__*/ _jsx(Details, {
                "data-component": "".concat(props['data-component'], "Details"),
                "data-testid": testIdName,
                id: props.detailsId,
                children: props.details
            })
        ]
    });
};
FormFieldLabel.displayName = 'FormFieldLabel';

//# sourceMappingURL=FormFieldLabel.js.map